import { render, staticRenderFns } from "./TwoColumnContentBlock.vue?vue&type=template&id=28f28efe&scoped=true&"
import script from "./TwoColumnContentBlock.vue?vue&type=script&lang=js&"
export * from "./TwoColumnContentBlock.vue?vue&type=script&lang=js&"
import style0 from "./TwoColumnContentBlock.vue?vue&type=style&index=0&id=28f28efe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28f28efe",
  null
  
)

export default component.exports